import React, { useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import axios from "axios";
import ReactStars from 'react-stars';
import { baseURL } from "../../constants/Api";
import ButtonLoader from "../../components/loaders/ButtonLoader";
import { FeedbackSubmitButtonClick } from "../../utils/Analytics";

function FeedBack(props) {
  const reservationId = localStorage.getItem("reservationId");
  const guestId = localStorage.getItem("guestId");
  const hotelId = localStorage.getItem("hotel-id");
  const appUserId = localStorage.getItem("appUserId");
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  let [isOpen, setIsOpen] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  function closeModal() {
    if(loading === false){
      props.hide();
    }
  }

  const ratingChanged = (newRating) => {
    setRating(newRating);
  };

  const handleFeedback = (e) => {
    setFeedback(e.target.value);
  };

  const FeedbackReq = async () => {
    var data = {
      reservationId,
      rating,
      feedback,
      appUserId,
    };
    setLoading(true);
    try {
      await axios({
        method: "post",
        url: `${baseURL}/api/feedbackV21`,
        data: data,
        headers: { "Content-Type": "application/json" },
        Accept: "application/json",
      }).then(function (response) {
        setLoading(false);
        if (response) {
          setSuccess(true);
          setTimeout(() => {
            closeModal();
          }, 5000);
        }
      });
    } catch (error) {
      setLoading(false);
      setError("Some thing went wrong..");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating === 0) {
      setError("Please select a rating.");
      return;
    }
    FeedbackSubmitButtonClick();
    FeedbackReq();
    setError("");
  };

  return (
    <div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-lg min-h-[300px] transform overflow-hidden rounded-xl bg-[#2E2842] p-6 text-left align-middle shadow-xl transition-all relative food-modal">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="modalBar mx-auto"></div>
                    {/* <button
                                            onClick={closeModal}
                                            className="mt-2"
                                        >
                                            <img src={CloseBtn} alt="" />
                                        </button> */}

                    <div className="text-lg mt-8 text-[#FFF] font-medium">
                      Share your Feedback
                    </div>
                    {/* <Rating /> */}
                    <div className="mt-8">
                      <label className="text-left text-[#D0D0D0] text-12px font-normal ">
                        Ratings
                      </label>
                    </div>
                    <ReactStars
                      count={5}
                      value={rating}
                      onChange={ratingChanged}
                      size={30}
                      color1={'#d6d4d4'}
                      color2={'#ffd700'}
                      className="inactive-stars mt-2"
                    />
                    <div className=" mt-8">
                      <label className="text-[#D0D0D0] text-xs">
                        Share Your Feedback
                      </label>
                    </div>
                    <textarea
                      className="mt-2 reqInput text-white w-full"
                      value={feedback}
                      onChange={handleFeedback}
                      type="textarea"
                      name=""
                      id=""
                    />
                    <button
                      disabled={loading}
                      className="bookBtn mt-4 relative"
                      onClick={handleSubmit}
                    >
                      Submit
                      {loading && <ButtonLoader />}
                    </button>
                    {error && (
                      <div className="w-full flex justify-center">
                        <div className="error-doc text-center mt-3">
                          {error}
                        </div>
                      </div>
                    )}
                    {success && (
                      <div className="w-full flex justify-center">
                        <div className="success-doc text-center mt-3">
                          Successfully Submitted!
                        </div>
                      </div>
                    )}
                  </Dialog.Title>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}

export default FeedBack;
